import { ChangeEvent } from "react";
import styled from "styled-components";

interface InputProps {
  jobName: string;
  typeName: string;
  inputName: string;
  inputValue: string;
  placeholder?: string;
  handleChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  noEdit?: boolean;
  inputStyle?: Object;
  autoComplete?: string;
  inputClassName?: string;
  inputConClassName?: string;
}

const InputBox: React.FC<InputProps> = ({
  jobName,
  typeName,
  inputName,
  inputValue,
  placeholder,
  handleChange,
  noEdit,
  inputStyle,
  autoComplete,
  inputClassName,
  inputConClassName,
}) => {
  return (
    <InputBoxWrapper
      style={{ alignSelf: "flex-end" }}
      className={inputConClassName}
    >
      <p>{jobName}</p>
      <input
        type={typeName}
        name={inputName}
        value={inputValue}
        onChange={handleChange}
        placeholder={placeholder}
        readOnly={noEdit} // to handle username being non-editable
        disabled={noEdit} // to remove focus from the username input
        style={inputStyle}
        autoComplete={autoComplete}
        className={inputClassName}
      />
    </InputBoxWrapper>
  );
};

export default InputBox;

const InputBoxWrapper = styled.div`
  align-self: flex-end;

  > input::placeholder {
    font-size: 14px;
  }
`;
